import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import * as moment from "moment";
import { FileUpload } from "primeng/fileupload";
import * as _ from "underscore";

import { GLOBAL_CONSTANT } from "../../../../app/common/constant/global.constant";
import { SessionService } from "../../../../app/common/services/session.service";
import { environment } from "../../../../environments/environment";
import { FILE_UPLOAD } from "../../../common/constant/fileupload.constant";
import { SharedService } from "../../service/api/shared.service";
import {
  IN_GeneralReq,
  IN_PhoneReq,
  IN_VoterIdReq,
} from "../../service/interface/shared.interface";
import { UtilityService } from "../../utility.service";
import { VoterSearchAPIService } from "src/app/voter-search/services/api/api.service";
import { IN_VisitorDataInterface } from "src/app/single-window-entry/interfaces/visitor-data.interface";
import { MessageService } from "primeng/api";
@Component({
  selector: 'app-voter-edit-form',
  templateUrl: './voter-edit-form.component.html',
  styleUrls: ['./voter-edit-form.component.scss']
})
export class VoterEditFormComponent implements OnInit {
  viewModel:any;
  isReadOnly: boolean = false;
  FMemberData: any;
  DeletedMember: Object;
  // NonVoterId: any;
  nonVoterModel:any = {};
  selectedFamilyMembers:any = [];
  // @Input() set isReadInput(value: boolean) {
  //   this.isReadOnly = value;
  // }
  @Input() set isReadInput(value) {
    if (value == true) {
      this.isReadOnly = true;
      this.voterFlag = true;
    } else {
      this.isReadOnly = false;
    }
  }
  @Input() set visitTabIndex(index) {
    if (index == "1") {
      this.hideInfoForm = true;
    }
  }
  @Output() afterRowSelection = new EventEmitter();
  @Output() errorMsgForMobile = new EventEmitter();
  @Output() onSearchTriChild = new EventEmitter();
  @Output() afterActualSave = new EventEmitter();

  _data: any;
  genderTypes: any;
  rationCardData: any;
  castData: any;
  subCastData: any;
  editableMode: boolean = false;
  isSearchVoter: boolean = false;
  searchByVoterId: IN_VoterIdReq;
  searchByGeneral: IN_GeneralReq;
  searchByPhone: IN_PhoneReq;
  officeId: any;
  netaFlag: boolean = false;
  userRole: any;
  maximunDate = new Date();
  yearRange: any;
  searchResp: any;
  searchResultListConfig: any;
  totalRecords: any;
  educationTypes: any;
  selectedRationCard: string;
  voterFlag: boolean = false;
  profileError: boolean = false;
  //assembly, Gaon And Gat_number
  assemblyData: Array<any>;
  gaonData: Array<any>;
  gatNumberData: Array<any>;
  ganData: Array<any>;
  prabhagData: Array<any>;
  prabhagAreaData: Array<any>;
  cityType: any;
  selectedCityType: any;
  selectedPrabhag: any;
  selectedPrabhagArea: any;
  selectedGoan: any;
  selectedGanNumber: any;
  villageFlag: boolean = false;
  cityFlag: boolean = false;
  gatNumberId: any;
  photoFlag: boolean = false;
  photo: any;
  selectedEducation: any;
  profilePhoto: any;
  //File Upload
  uploadAPI = FILE_UPLOAD.Profile_image;
  @ViewChild("imageUpload", { static: false }) imageUpload: FileUpload;
  uploadedFiles = [];
  apiBaseUrl = environment.API_BASE;
  filetype = FILE_UPLOAD.File_type;
  picture: any;
  _entityName: string = "profileImage";
  previewImg: string = "assets/icons/userpro.png";
  hideInfoForm: boolean;
  message: string;
  nagarOptions:any[];
  societyOptions:any[];
  displayDialog: boolean = false;
  displayDialog2: boolean = false;
  selectedItems: any[] = [];
  searchFormModel: any;//IN_SearchByWild;
  myData : any
  arr :any = []
  loadForm:boolean=false;


  @Input() set data(val) {
    if (val !== null && val !== undefined) {
      //this._data = val;
      this.getVisitorForEdit(val.id);
    }
  }
  get data() {
    return this._data;
  }

  @Input() form;
  @Input() showErrorMsg;
  @Input() showMandatoryMark;
  @Input() showMobileError;

  @Input() componentId;

  constructor(

    private service: SharedService,
    private sessionService: SessionService,
    private utilityService: UtilityService,
    private voterService: VoterSearchAPIService,
    private messageService: MessageService
  ) {
    this._init();
    this.rationCardData = GLOBAL_CONSTANT.RATIONCARD_DATA;
    this.genderTypes = GLOBAL_CONSTANT.GENDER_TYPES;
    this.cityType = GLOBAL_CONSTANT.CITY_TYPES;
    this.educationTypes = GLOBAL_CONSTANT.EDUCATION_TYPE;
    this._initSearchByVoterId();
    this._initSearchByPhone();
    this._initsearchByGeneral();
    this.yearRange = this.utilityService.CalYearRange();
  }
  
  calculateAge(dob) {
    if (this._data.dob != null) {
      dob = new Date(dob.model);
      if (dob != "Invalid Date") {
        this._data.age = moment().diff(dob, "years");
      }
      this._data.dob = new Date(
        Date.UTC(dob.getFullYear(), dob.getMonth(), dob.getDate())
      );
    } else {
      this._data.age = 0;
    }
  }

  getCast() {
    this.service.getCast().subscribe((res: any) => {
      this.castData = res;
      if (this.editableMode && this._data.cast != undefined) {
        this.castData.filter((cast) => {
          cast.id === this._data.cast["id"] ? (this._data.cast = cast) : "";
          this.getsubcastWithCast(this._data.cast["id"]);
        });
      }
    });
  }
 

  onChangeEducation(selectedEducation) {
    this._data.education = selectedEducation.value;
  }

  onChangeCast() {
    let selectedCastId = this._data.cast["id"];
    this.getsubcastWithCast(selectedCastId);
  }

  getsubcastWithCast(id) {
    this.castData.forEach((element) => {
      if (element.id == id) {
        this.subCastData = element.subcast;
        if (this.editableMode === true) {
          this.subCastData.filter((ctype) => {
            ctype.id === this._data.subcast ? (this._data.subcast = ctype) : "";
          });
        }
      }
    });
  }

  onChangeRationCard(selectedRationCard) {
    this._data.rationCard = selectedRationCard.value;
  }

  searchVoter() {
    this.isSearchVoter = true;
  }

  onSearchByVoterId() {
    JSON.parse(JSON.stringify(this.searchByVoterId));
    this.service.searchByVoterId(this.searchByVoterId).subscribe(
      (resp: any) => {
        this.searchResp = resp[0];
        this.totalRecords = resp[1];
      },
      (error) => { }
    );
    this._initsearchByGeneral();
    this._initSearchByPhone();
  }

  onSearchByPhone() {
    this.service.searchByPhone(this.searchByPhone).subscribe(
      (resp: any) => {
        this.searchResp = resp[0];
        this.totalRecords = resp[1];
      },
      (error) => { }
    );
    this._initsearchByGeneral();
    this._initSearchByVoterId();
  }

  onSearchByGeneral() {
    this.service.searchByGeneral(this.searchByGeneral).subscribe(
      (resp: any) => {
        this.searchResp = resp[0];
        this.totalRecords = resp[1];
      },
      (error) => { }
    );
    this._initSearchByVoterId();
    this._initSearchByPhone();
  }

  private _initSearchByVoterId() {
    this.searchByVoterId = {
      type: "VOTERID",
      filters: {
        voterID: "",
      },
      page: {
        number: 0,
        size: 5,
      },
    };
  }

  private _initSearchByPhone() {
    this.searchByPhone = {
      type: "PHONE",
      filters: {
        phone: "",
      },
      page: {
        number: 0,
        size: 5,
      },
    };
  }

  private _initsearchByGeneral() {
    this.searchByGeneral = {
      type: "GENERAL",
      filters: {},
      page: {
        number: 0,
        size: 5,
      },
    };
  }

  allReset() {
    this._initSearchByVoterId();
    this._initSearchByPhone();
    this._initsearchByGeneral();
    this.onSearchByVoterId();
  }

  ClearSearchData() {
    this.searchByVoterId.filters.voterID = "";
    this.allReset();
  }

  ClearSearch() {
    this.searchByPhone.filters.phone = "";
    this.allReset();
  }

  ClearData() {
    this.searchByGeneral.filters.gender = "";
    this.searchByGeneral.filters.firstName = "";
    this.searchByGeneral.filters.middleName = "";
    this.searchByGeneral.filters.lastName = "";
    this.allReset();
  }

  handleEvent(event) {
    if (event.name == "LAZY_LOAD") {
    }
    if (event.name == "SELECT") {
      this.afterRowSelection.emit({ data: event.data });
      this._data = event.data;
      this.isSearchVoter = false;
      this.hideInfoForm = false;
      this.isReadOnly = true;
    }
  }

  getSearchResultListConfig() {
    this.service.getSearchResultListConfig().subscribe((res) => {
      this.searchResultListConfig = res;
    });
  }

  //onChange methods
  onChangeAssembly(event) {
    this._data.assembly = event.value;
  }

  onChangeCityType(event) {
    if (event.value === "VILLAGE") {
      this.villageFlag = true;
      this.cityFlag = false;
      if (this._data.assembly) {
        this._data.cityType = event.value;
        this.getGaonList(this._data.assembly.id);
      }
    } else if (event.value === "CITY") {
      this.cityFlag = true;
      this.villageFlag = false;
      if (this._data.assembly) {
        this._data.cityType = event.value;
        this.getPrabhagList(this._data.assembly.id);
      }
    }
  }

  onChangeGat(event) {
    this._data.gat_number = event.value;
  }

  onChangeGan(event) {
    this.getGatNoList(this.gatNumberId);
  }

  onChangeGaon(event) {
    this.gatNumberId = event.value.ganNumber.gatNumber.id;
    this.getGanList(event.value.ganNumber.id);
    delete event.value.ganNumber;
    this._data.gaon = event.value;
  }

  onChangePrabhag(event) {
    this._data.prabhag = event.value;
    this.getPrabhagAreaList(event.value.id);
  }

  onChangePrabhagArea(event) {
    this._data.prabhagArea = event.value;
  }
  //Assembly Data
  getAsseblyList() {
    this.service.getAssemblyData().subscribe((ele: any) => {
      this.assemblyData = ele;
      if (this.editableMode && this._data.assembly != null) {
        this.getCityType(this._data.assembly.id);
      }
    });
  }

  //Gat_number List
  getGatNoList(id) {
    this.service.getGatNumberData(id).subscribe((res: any) => {
      this.gatNumberData = res;
    });
  }

  //Gan List
  getGanList(id) {
    this.service.getGanNumberData(id).subscribe((res: any) => {
      this.ganData = res;
      if (this.editableMode) {
        this.getGatNoList(this._data.gat_number.id);
      }
    });
  }

  //Gaon List
  getGaonList(id) {
    this.service.getGaonDataWithAssembly(id).subscribe((res: any) => {
      this.gaonData = res[0];
    });
  }
  //Gaon List
  getGaon(id) {
    this.service.getGaonData(id).subscribe((res: any) => {
      this.gaonData = res;
      if (this.editableMode) {
        this.getGanList(this._data.gan_number.id);
      }
    });
  }

  //Prabhag
  getPrabhagList(id) {
    this.service.getPrabhagData(id).subscribe((res: any) => {
      this.prabhagData = res;
      if (this.editableMode && this._data.prabhag.id) {
        this.getPrabhagAreaList(this._data.prabhag.id);
      }
    });
  }

  // prabhag area
  getPrabhagAreaList(id) {
    this.service.getPrabhagAreaData(id).subscribe((res: any) => {
      this.prabhagAreaData = res;
    });
  }

  // city type
  getCityType(id) {
    if (this._data.cityType == "VILLAGE") {
      this.villageFlag = true;
      this.cityFlag = false;
      if (this._data.assembly) {
        this.getGaon(this._data.gaon.id);
      }
    } else {
      this.cityFlag = true;
      this.villageFlag = false;
      if (this._data.assembly) {
        this.getPrabhagList(this._data.assembly.id);
      }
    }
  }

  //profile image
  saveProfile() {
    if (this.uploadedFiles.length >= 0) {
      this.imageUpload.upload();
    }
  }

  onUploadSuccess($event) {
    let d = $event.originalEvent.body.files;
    if (!this.editableMode) {
      this._data.ProfileImage = JSON.stringify(d);
    } else if (this.editableMode) {
      if (d && d.length != 0) {
        this._data.ProfileImage = JSON.stringify(d);
      } else {
        if (this.photo && this.photo != undefined) {
          this._data.ProfileImage = JSON.stringify(this.photo);
        } else {
          this._data.ProfileImage = JSON.stringify(d);
        }
      }
    }
    if (this._data.ProfileImage) {
      if (
        this._data.ProfileImage.length != 0 &&
        this._data.ProfileImage != "[]"
      ) {
        this.photo = JSON.parse(this._data.ProfileImage);
        this.profilePhoto = this.photo[0].filename;

        this.previewImg =
          this.apiBaseUrl +
          "/file-uploader/downloadS3?path=" +
          this.profilePhoto;
      }
    }
  }

  onUploadError($event) {
    this.profileError = true;
  }

  closePopup() {
    this.isSearchVoter = false;
  }
  // Check Existing Number
  checkExistingNo(obj) {
    let data = { phone: obj.target.value }
    this.service.checkExistingNumber(data).subscribe(
      (res: any) => { },
      (err: any) => {
        this.message = err.error.message;
        this.errorMsgForMobile.emit({ data: this.message });
      }
    )
  }
  getNagarList() {
    this.nagarOptions = [];
    this.service.getAreaNagarList().subscribe((res => {
      let c = res['areaList'];
      if(c && c.length>0){
        c.forEach(element => {
          this.nagarOptions.push({label: element, value: element})
        });
      }
    }))
  }

  getSocietyList() {
    this.societyOptions = [];
    this.service.getSocietyVastiList().subscribe((res => {
      let c = res['societyList'];
      if(c && c.length>0){
        c.forEach(element => {
          this.societyOptions.push({label: element, value: element})
        });
      }

    }))
  }
  getFMember() {
    this.voterService.getFamilyMember(this._data.id).subscribe((res => {
      this.viewModel.FMemberData = res;
      this._data.familyMembers =_.pluck(res, 'id');
      console.log(this._data.familyMembers);
      this.closeDialog();
      this.closeDialog2();
    }))
  }

  getVisitorForEdit(id) {
    this.voterService.getVisitorForEdit(id).subscribe((res => {
      this._data = res;
      this.postDataProcess();
      this.getFMember();
      this.loadForm = true;
    }))
  }
  updateRecord(){
    this.voterService.updateRecord(this._data).subscribe((res => {
      this.afterActualSave.emit({ type: "SAVE", data: {} });
    }))
  }
  cancelUpdateRecord(){
    this.afterActualSave.emit({ type: "SAVE", data: {} });
  }

  postDataProcess(){
    if (!this._data.addressFields) {
      this._data.addressFields = {};
      this._data.extraFields = {};
    }

    if(!("addressLine1" in this._data.addressFields)){
      this._data.addressFields.addressLine1 = "";
    }
    if(!("addressLine2" in this._data.addressFields)){
      this._data.addressFields.addressLine2 = "";
    }

    if (this._data.type !== undefined && this._data.type == "Voter") {
      this.voterFlag = true;
    }

    if (this._data.dob) {
      this._data.dob !== null
        ? (this._data.dob = new Date(this._data.dob))
        : null;
    }

    if (this._data.id) {
      this.editableMode = true;
    }

    if (this._data.cast) {
      this.getCast();
    }

    if (this._data.rationCard) {
      this.selectedRationCard = _.find(this.rationCardData, (a) => {
        return a.value === this._data.rationCard;
      });
    }

    if (this._data.education) {
      this.selectedEducation = _.find(this.educationTypes, (a) => {
        return a.value === this._data.education;
      });
    }

    //city find
    if (this._data.cityType) {
      this.selectedCityType = _.find(this.cityType, (a) => {
        return a.value === this._data.cityType;
      });
      if (this._data.assembly !== null && this._data.assembly.id) {
        this.getCityType(this._data.assembly.id);
      }
    }

    //set profileimage
    if (this._data.ProfileImage) {
      if (
        this._data.ProfileImage.length != 0 &&
        this._data.ProfileImage != "[]"
      ) {
        this.photo = JSON.parse(this._data.ProfileImage);
        this.profilePhoto = this.photo[0].filename;

        if (this.profilePhoto.indexOf(this._entityName) > -1) {
          this.picture =
            this.apiBaseUrl +
            "/file-uploader/downloadS3?path=" +
            this.profilePhoto;
        } else {
          this.picture =
            this.apiBaseUrl +
            "/file-uploader/file2?path=" +
            this._entityName +
            `/${this.profilePhoto}`;
        }
      }
    }

    if (this.profilePhoto != null || this.profilePhoto != undefined) {
      this.photoFlag = true;
    }
  }

  showDialog() {
    this.displayDialog = true;
  }
  closeDialog() {
    if(this.displayDialog){
      this.displayDialog = false;
    }
  }
  showDialog2() {
    this.displayDialog2 = true;
  }
  closeDialog2() {
    if(this.displayDialog2){
      this.displayDialog2 = false;
    }
  }
  private _init() {
    this.searchFormModel = {
      type: "BYNAME",
      filters: {},
      page: {
        number: 0,
        size: 10,
      },
    };

    this.nonVoterModel = {
      firstName: "",
      middleName: "",
      lastName: "",
      gender: "",
      isVoter:false,
      dob:"",
      fullName:""
    }
    this.viewModel = {};
  }
  saveNonVoter() {
    if(this.nonVoterModel.gender.length < 1){
      return;
    }
    this.displayDialog2 = false;
    this.nonVoterModel.fullName = `${this.nonVoterModel.firstName} ${this.nonVoterModel.middleName} ${this.nonVoterModel.lastName}`  
    this.voterService.createVoterData(this.nonVoterModel).subscribe(
      (res:any) => {  
        setTimeout(() => {
          this.saveFamilyMember(res.id);
          this.nonVoterModel = {
           firstName: "",
           middleName: "",
           lastName: "",
           gender: "",
           isVoter:false,
           dob:"",
           fullName:""
         }         
        }, 100);
      },
    );
  }

  private saveFamilyMember(familyMemberId: any) {
    this.voterService.addFamilyMember({parentId:this.data.id,member:familyMemberId}).subscribe(
      (res:any) => {
        setTimeout(() => {
          this.getFMember();  
        }, 500);        
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Voter Added Successfully' });
      },
    );
  }

  _triggerSearch() {
    let searchPayloadModel: any = {};
    let dd = {};
    if (this.searchFormModel.filters) {
      dd = JSON.parse(JSON.stringify(this.searchFormModel.filters));
    }
    searchPayloadModel = this._processLocalVariables(searchPayloadModel);
    this.onSearchTriChild.emit({
      data: JSON.parse(JSON.stringify(this.searchFormModel)),
    });
    console.log(this._processLocalVariables(searchPayloadModel));
  }

  _processLocalVariables(searchPayloadModel) {
    return searchPayloadModel;
  }
  triggerSearch(voterSearchForm) {
    this._onSearchByName(voterSearchForm);

  }
  private _onSearchByName(searchByName) {
    this.voterService.searchByName(this.searchFormModel).subscribe(
      (resp: any) => {
        this.searchResp = resp;
        console.log("this.searchResp",this.searchResp);
        // this.afterSearchData.emit({
        //   data: JSON.parse(JSON.stringify(this.searchResp)),
        // });
      },
      (error) => {}
    );
  }
  onAddButtonClick(row) {
   this.saveFamilyMember(row.id)
    this.closeDialog()
  }
  DeleteFamilyMember(data){
    this.voterService.removeFamilyMember({parentId:this.data.id,member:data.id}).subscribe((res => {
      this.DeletedMember = res;
      this.messageService.add({ severity: 'warn', summary: 'Delete', detail: 'Deleted Successfully' });
      this.getFMember();
    }))
  }
  // check(res : any){
  //   this.arr.push(res)
  //   this.myData = this.arr
  // }

  ngOnInit() {
    this._init();
    this.getNagarList();
    this.getSocietyList()
    this.getCast();
    this.getSearchResultListConfig();
    this.getAsseblyList();
    this.officeId = this.sessionService.getOffice();
    this.userRole = this.sessionService.getUserInfo().role;
    let vv = this.sessionService.isVirtualView();
    if (this.userRole == "VIEWER" || vv) {
      this.netaFlag = true;
    }
  }

}
